var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDataList',{ref:"dataList",attrs:{"items":_vm.projects,"service":_vm.fetchProjects},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('ProjectListHeader')]},proxy:true},{key:"default",fn:function({ item }){return [_c('ProjectListItem',{attrs:{"product-id":_vm.productId,"project":item},on:{"project-removed":_vm.refreshList}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }